import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UsersService } from '@app/services/users.service';
import { UploadsService } from '../uploads.service';
import { commonLanguages } from '@app/translateLanguages';
import { EngineKeyToNameMap, EngineList } from '@app/shared/engine-list';

interface ViewModel {
    form: FormGroup;
}

@Component({
    selector: 'app-submit-upload',
    templateUrl: './submit-upload.component.html',
    styleUrls: ['./submit-upload.component.scss']
})
export class SubmitUploadComponent implements OnInit {
    viewModel: ViewModel;

    engine: string = EngineList.Google;
    engines;
    public language: string = 'en';
    languages;
    public multipleSpeakers: boolean;

    constructor(
        private ref: MatDialogRef<SubmitUploadComponent>,
        private usersService: UsersService,
        private uploadsService: UploadsService,
        @Inject(MAT_DIALOG_DATA) public data
    ) {}

    ngOnInit() {
        this.engines = [];

        this.loadAvailableEngines();

        this.viewModel = {
            form: new FormGroup({
                multipleSpeakers: new FormControl(false),
                engine: new FormControl(),
                language: new FormControl()
            })
        }

        this.languages = commonLanguages.map(lang => ({
            label: lang.label,
            value: lang.value
        }));

        this.language = 'en';
    }

    displayFn(item: any) {
        return item && item.label ? item.label : '';
    }

    languageChanged($event: any) {
        this.language = $event.value.value;
    
    }

    loadAvailableEngines() {
        this.usersService.getPermissions().subscribe(res => {

            res.sort((a, b) => a.name.localeCompare(b.name))
            .map(permission => {
                const engine = EngineKeyToNameMap[permission.name];
                if (engine) {
                    this.engines.push({ label: engine, value: engine });
                }
            })
        });

        if (this.engines.length > 0) {
            this.engine = this.engines[0];
            this.viewModel.form.get('engine').setValue(this.engine);
        }
    }

    async upload() {
        this.multipleSpeakers = JSON.parse(this.viewModel.form.get('multipleSpeakers').value);
        this.ref.close({ multipleSpeakers: this.multipleSpeakers, engine: this.engine, language: this.language });
    }
}